import React, { useMemo } from 'react'
import classnames from 'classnames'
import parse from 'html-react-parser'
import { Typography } from 'shared/ui'
import type { Attachment } from 'entities/Attachment/model/Attachment'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { textToHtml } from 'entities/Message/lib/textToHtml'
import { Attachments } from 'widgets/Attachments'
import styles from './styles.module.scss'

type ISMSContentProps = {
  attachments: Attachment[]
  message: string
  isDetailsMode?: boolean
  isAccentedMessage?: boolean
}

export const SMSContent = ({
  attachments,
  message,
  isDetailsMode,
  isAccentedMessage = true,
}: ISMSContentProps) => {
  const entities = useEntitiesContext()
  const messageParse = useMemo(() => {
    if (message) {
      return parse(
        textToHtml(entities, {
          text: message,
          replaceNewRow: true,
        })
      )
    }
  }, [message])
  return (
    <div className={styles.wrap}>
      {!!attachments?.length && (
        <div
          className={classnames(styles.wrapAttachments, {
            [styles.accentedMessage]: isAccentedMessage,
          })}
        >
          <Attachments attachments={attachments} isDetailsMode={isDetailsMode} />
        </div>
      )}
      {isAccentedMessage && messageParse && (
        <Typography
          variant={'body-rg-regular'}
          className={classnames(styles.message, styles.accentedMessage)}
          tag={'div'}
          ariaLabel={'message'}
        >
          {messageParse}
        </Typography>
      )}
      {!isAccentedMessage && messageParse && (
        <Typography
          variant={'text-input-field-r'}
          className={classnames(styles.message)}
          tag={'div'}
          ariaLabel={'message'}
        >
          {messageParse}
        </Typography>
      )}
    </div>
  )
}
